import { render, staticRenderFns } from "./taxSupplementaryReportPP36.vue?vue&type=template&id=2e812182&scoped=true"
import script from "./taxSupplementaryReportPP36.vue?vue&type=script&lang=js"
export * from "./taxSupplementaryReportPP36.vue?vue&type=script&lang=js"
import style0 from "./taxSupplementaryReportPP36.vue?vue&type=style&index=0&id=2e812182&prod&scoped=true&lang=css"
import style1 from "./taxSupplementaryReportPP36.vue?vue&type=style&index=1&id=2e812182&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e812182",
  null
  
)

export default component.exports